module.exports = __webpack_public_path__ + "static/Sunrise Serenity-16d1c461f2b821f6bb934d2c3a04a557.jpg";